import { Provider } from '@repo/api-gw-sdk';

import { ButtonWithIcon } from '../buttons/buttonWithIcon';
import { getCloudFieldConfig } from '../form/validation/cloudFieldValidation';

const generateKmsKeyUrl = (kmsArn?: string) => {
  const kmsRegion = kmsArn?.split('arn:aws:kms:')[1]?.split(':')[0];
  const baseUrl = `https://${kmsRegion}.console.aws.amazon.com/kms/home?region=${kmsRegion}#/kms/keys`;
  const kmsId = kmsArn?.split(':key/')[1];
  return kmsId ? `${baseUrl}/${kmsId}/editPolicy` : baseUrl;
};

const arnConfig = getCloudFieldConfig(Provider.Aws, 'kmsKeyArn');

export const KmsEditKeyPolicyButton = ({ kmsKey }: { kmsKey?: string }) => {
  const disabled = !kmsKey || !arnConfig.validation.validateInput(kmsKey);

  return (
    <ButtonWithIcon
      variant='contained'
      disabled={disabled}
      text='Edit Key Policy in AWS'
      icon='material-symbols-open-in-new'
      iconPosition='right'
      onClick={() => window.open(generateKmsKeyUrl(kmsKey), '_blank')}
    />
  );
};
